import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-w-40 tw-flex-none tw-self-center tw-overflow-hidden @sm:tw-block @sm:tw-w-28"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "tw-p-1"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tw-aspect-video tw-w-full tw-max-w-[180px] tw-self-start tw-rounded tw-bg-slate-100 tw-object-cover dark:tw-bg-slate-700" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "tw-block tw-w-full tw-flex-1 tw-px-4" }
const _hoisted_7 = { class: "tw-flex tw-items-center" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "tw-flex-none tw-pr-3 @lg:tw-pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    "data-testid": "studio-list-item",
    class: _normalizeClass(["@container studioListItem tw-group tw-relative tw-flex tw-cursor-pointer tw-items-center tw-transition-all hover:tw-bg-slate-50", {
      'tw-group tw-rounded tw-border-2 tw-border-deep-orange-600 tw-bg-slate-100': $props.selected,
      'hover:dark:tw-bg-slate-900': !$props.selected,
      '!tw-cursor-default': !$props.clickable,
      'tw-pointer-events-none': $props.disabled
    }]),
    onClick: _cache[0] || (_cache[0] = e => _ctx.$emit('click', e))
  }, [
    _renderSlot(_ctx.$slots, "image-preview", {}, () => [
      (!$props.noImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($props.imageSrc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $props.imageSrc,
                  class: "tw-mr-4 tw-aspect-video tw-w-full tw-max-w-[180px] tw-self-start tw-rounded-md tw-p-1",
                  alt: "",
                  "data-testid": "studio-list-item-image"
                }, null, 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "badges"),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["tw-truncate tw-text-base tw-text-black @sm:tw-text-sm dark:tw-text-white", {
            'dark:tw-text-black': $props.selected,
            'tw-max-w-xs tw-truncate tw-text-ellipsis lg:tw-max-w-sm': $props.truncateTitle
          }]),
          "data-testid": "studio-list-item-title",
          title: $props.truncateTitle ? $props.title : undefined
        }, _toDisplayString($props.title), 11, _hoisted_8),
        _renderSlot(_ctx.$slots, "info")
      ]),
      _createElementVNode("div", {
        class: "ellipsisOneLine tw-text-xs tw-text-slate-500",
        "data-testid": "studio-list-item-subtitle",
        innerHTML: $props.subTitle
      }, null, 8, _hoisted_9),
      _renderSlot(_ctx.$slots, "body")
    ]),
    _renderSlot(_ctx.$slots, "center"),
    _createElementVNode("div", _hoisted_10, [
      _renderSlot(_ctx.$slots, "right")
    ])
  ], 2))
}